import React, { useState } from "react";

const WORKFLOW_STAGES = {
  requirements: {
    step: 1,
    title: "Create & manage requirements",
    help: "Open a client requirement with positions, skills, and assigned recruiters. Use the count grid or Links section to track submissions and interviews.",
    next: "Add candidates against this requirement.",
  },
  candidates: {
    step: 2,
    title: "Submit candidates",
    help: "Link each candidate to a client and requirement. After saving, update status — statuses marked for scheduling will open the interview form.",
    next: "Schedule interviews when the profile is ready.",
  },
  interviews: {
    step: 3,
    title: "Schedule & track interviews",
    help: "Record round, date, time, and outcome. Pick the candidate first — client and requirement are filled automatically.",
    next: "Create an onboard record when the candidate is selected to join.",
  },
  onboards: {
    step: 4,
    title: "Onboard selected candidates",
    help: "Capture joining details and compensation. Candidate and requirement fields can be prefilled when you arrive from a candidate or interview.",
    next: "Use Offboards when the consultant exits.",
  },
  dashboard: {
    step: 0,
    title: "Recruitment overview",
    help: "Pipeline counts show recruiter progress for the selected month. Click highlighted numbers to open the related list.",
    next: "Drill into Requirements → Candidates → Interviews → Onboards for details.",
  },
};

export default function WorkflowHelpBanner({ stage = "requirements", compact = false }) {
  const [expanded, setExpanded] = useState(false);
  const info = WORKFLOW_STAGES[stage];
  if (!info) return null;

  if (compact) {
    return (
      <div className="alert alert-light border py-2 px-3 mb-2 small workflow-help-compact">
        <div className="d-flex align-items-center flex-wrap gap-2">
          <span>
            <i className="ri-route-line me-1 text-primary" />
            <strong>Step {info.step || "—"}:</strong> {info.title}
          </span>
          <button
            type="button"
            className="btn btn-link btn-sm p-0 text-decoration-none"
            onClick={() => setExpanded((prev) => !prev)}
            aria-expanded={expanded}
          >
            {expanded ? "Hide guide" : "Show guide"}
            <i className={`ri-arrow-${expanded ? "up" : "down"}-s-line ms-1`} />
          </button>
        </div>
        {expanded && (
          <div className="text-muted mt-2 pt-2 border-top workflow-help-compact-body">
            <div>{info.help}</div>
            <div className="mt-2">
              <span className="badge bg-primary-transparent text-primary me-1">Next</span>
              {info.next}
            </div>
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="alert alert-info border-0 py-2 px-3 mb-3 small">
      <div className="d-flex align-items-start gap-2">
        <i className="ri-lightbulb-line fs-5 text-primary mt-1" />
        <div>
          <strong>
            Hiring workflow — Step {info.step > 0 ? `${info.step} of 4` : "overview"}: {info.title}
          </strong>
          <div className="text-muted mt-1">{info.help}</div>
          <div className="mt-1">
            <span className="badge bg-primary-transparent text-primary me-1">Next</span>
            {info.next}
          </div>
        </div>
      </div>
    </div>
  );
}
